import { LANGS } from '@procumi/shared';
import { chooseLang, lang } from '../lib/i18n';

/**
 * Limba ecranelor de dinainte de intrare (login, înscriere, invitație, parolă nouă).
 * După intrare limba e a omului, din „Profilul meu”.
 */
export function LangSwitch() {
  return (
    <div className="lang-switch" role="group" aria-label="Language / Limba">
      {LANGS.map((l) => (
        <button
          key={l.id}
          type="button"
          className={l.id === lang() ? 'on' : undefined}
          aria-pressed={l.id === lang()}
          onClick={() => chooseLang(l.id)}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
